<div class="d-flex flex-column flex-root app-root" id="kt_app_root">
  <div class="app-page flex-column flex-column-fluid" id="kt_app_page">
    <div id="kt_app_header" class="app-header" data-kt-sticky="true" data-kt-sticky-activate="{default: true, lg: true}"
      data-kt-sticky-name="app-header-minimize" data-kt-sticky-offset="{default: '200px', lg: '0'}"
      data-kt-sticky-animation="false">
      <div class="app-container container-fluid d-flex align-items-stretch justify-content-between"
        id="kt_app_header_container">
        <div class="d-flex align-items-center d-lg-none ms-n3 me-1 me-md-2" title="Show sidebar menu">
          <div class="btn btn-icon btn-active-color-primary w-35px h-35px" id="kt_app_sidebar_mobile_toggle">
            <i class="ki-duotone ki-abstract-14 fs-2 fs-md-1">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>
        <div class="d-flex align-items-center flex-grow-1 page-header-container">
          <a routerLink="/landing" class="d-lg-none">
            <img alt="Logo" src="assets/image/logo.png" class="h-30px" />
          </a>
          <div *ngIf="heading || subheading" class="page-header-text d-flex flex-column justify-content-center py-2 ms-3 ms-lg-0">
            <h1 *ngIf="heading" id="heading" class="page-heading mb-1">{{ heading }}</h1>
            <p *ngIf="subheading" id="subheading" class="page-subheading mb-0">{{ subheading }}</p>
          </div>
        </div>
        <div class="app-navbar flex-shrink-0">
          <div class="app-navbar-item ms-1 ms-md-4" id="kt_header_user_menu_toggle">
            <div class="cursor-pointer symbol symbol-35px" data-kt-menu-trigger="{default: 'click', lg: 'hover'}"
              data-kt-menu-attach="parent" data-kt-menu-placement="bottom-end">
              <img src="assets/media/avatars/300-3.jpg" class="rounded-3" alt="user">
            </div>
            <div
              class="menu menu-sub menu-sub-dropdown menu-column menu-rounded menu-gray-800 menu-state-bg menu-state-color fw-semibold py-4 fs-6 w-275px"
              data-kt-menu="true">
              <div class="menu-item px-3">
                <div class="menu-content d-flex align-items-center px-3">
                  <div class="symbol symbol-50px me-5">
                    <img alt="Logo" src="assets/media/avatars/300-3.jpg">
                  </div>
                  <div class="d-flex flex-column">
                    <div class="fw-bold d-flex align-items-center fs-5">
                      {{EmployeeName}}
                    </div>
                    <a href="#" class="fw-semibold text-muted text-hover-primary fs-7">
                      {{DesignationName}}
                    </a>
                    <span class="fw-semibold text-muted text-hover-primary fs-7">
                      {{ storageService.getLoginDateTime() }}
                    </span>
                  </div>
                </div>
              </div>
              <div class="separator my-2"></div>
              <div class="menu-item px-5">
                <a [routerLink]="profileUrl" class="menu-link px-5">My Profile</a>
              </div>
              <div class="menu-item px-5">
                <a href="javascript:void(0)" class="menu-link px-5">
                  <span class="menu-text">My Projects</span>
                  <span class="menu-badge">
                    <span class="badge badge-light-danger badge-circle fw-bold fs-7">3</span>
                  </span>
                </a>
              </div>
              <div class="menu-item px-5">
                <a href="#" class="menu-link px-5" (click)="btnSignOut()">Sign Out</a>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div class="app-wrapper flex-column flex-row-fluid" id="kt_app_wrapper">
      <div id="kt_app_sidebar" class="app-sidebar flex-column" data-kt-drawer="true" data-kt-drawer-name="app-sidebar"
        data-kt-drawer-activate="{default: true, lg: false}" data-kt-drawer-overlay="true" data-kt-drawer-width="225px"
        data-kt-drawer-direction="start" data-kt-drawer-toggle="#kt_app_sidebar_mobile_toggle">
        <div class="app-sidebar-logo px-6" id="kt_app_sidebar_logo">
          <a routerLink="/landing">
            <img alt="Logo" src="assets/image/logo.png" class="h-25px app-sidebar-logo-default" href="landing" />
            <img alt="Logo" src="assets/image/logo.png" class="h-20px app-sidebar-logo-minimize" href="landing" />
          </a>
          <div id="kt_app_sidebar_toggle"
            class="app-sidebar-toggle btn btn-icon btn-shadow btn-sm btn-color-muted btn-active-color-primary h-30px w-30px position-absolute top-50 start-100 translate-middle rotate"
            data-kt-toggle="true" data-kt-toggle-state="active" data-kt-toggle-target="body"
            data-kt-toggle-name="app-sidebar-minimize">
            <i class="ki-duotone ki-black-left-line fs-3 rotate-180">
              <span class="path1"></span>
              <span class="path2"></span>
            </i>
          </div>
        </div>

        <div class="app-sidebar-menu overflow-hidden flex-column-fluid">
          <div id="kt_app_sidebar_menu_wrapper" class="app-sidebar-wrapper">
            <div id="kt_app_sidebar_menu_scroll" class="scroll-y my-5 mx-3">
              <div class="menu menu-column menu-rounded fw-semibold fs-6 mb-4" id="kt_app_sidebar_menu"
                data-kt-menu="true">
                <ng-container *ngFor="let parent of sidebarMenu[0]">

                  <!-- Parent with children -->
                  <div *ngIf="sidebarMenu[parent.id]" class="menu-item menu-accordion" data-kt-menu-trigger="click">
                    <a class="menu-link"
                      [routerLink]="parent.url || null">
                      <span class="menu-icon">
                        <i [ngClass]="parent.icon">
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                          <span class="path4"></span>
                          <span class="path5"></span>
                          <span class="path6"></span>
                        </i>
                      </span>

                      <span class="menu-title">
                        {{ parent.name }}
                      </span>
                      <span class="menu-arrow"></span>
                    </a>

                    <div class="menu-sub menu-sub-accordion">
                      <ng-container *ngFor="let child of sidebarMenu[parent.id]">
                        <div *ngIf="sidebarMenu[child.id]" class="menu-item menu-accordion"
                          data-kt-menu-trigger="click">

                          <a class="menu-link"
                            [routerLink]="child.url || null">

                            <span class="menu-icon">
                              <i [ngClass]="child.icon">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                                <span class="path4"></span>
                                <span class="path5"></span>
                                <span class="path6"></span>
                              </i>
                            </span>
                            <span class="menu-title">
                              {{ child.name }}
                            </span>
                            <span class="menu-arrow"></span>
                          </a>
                          <div class="menu-sub menu-sub-accordion">
                            <div *ngFor="let sub of sidebarMenu[child.id]" class="menu-item">
                              <a [routerLink]="sub.url" routerLinkActive="active" class="menu-link">
                                <span class="menu-icon">
                                  <i [ngClass]="sub.icon">
                                    <span class="path1"></span>
                                    <span class="path2"></span>
                                    <span class="path3"></span>
                                    <span class="path4"></span>
                                    <span class="path5"></span>
                                    <span class="path6"></span>
                                  </i>
                                </span>
                                <span class="menu-title">
                                  {{ sub.name }}
                                </span>
                              </a>
                            </div>
                          </div>
                        </div>
                        <div *ngIf="!sidebarMenu[child.id]" class="menu-item">
                          <a [routerLink]="child.url" routerLinkActive="active" class="menu-link">
                            <span class="menu-icon">
                              <i [ngClass]="child.icon">
                                <span class="path1"></span>
                                <span class="path2"></span>
                                <span class="path3"></span>
                                <span class="path4"></span>
                                <span class="path5"></span>
                                <span class="path6"></span>
                              </i>
                            </span>
                            <span class="menu-title">
                              {{ child.name }}
                            </span>
                          </a>
                        </div>
                      </ng-container>
                    </div>
                  </div>

                  <div *ngIf="!sidebarMenu[parent.id]" class="menu-item">
                    <a [routerLink]="parent.url" routerLinkActive="active" class="menu-link">
                      <span class="menu-icon">
                        <i [ngClass]="parent.icon">
                          <span class="path1"></span>
                          <span class="path2"></span>
                          <span class="path3"></span>
                          <span class="path4"></span>
                          <span class="path5"></span>
                          <span class="path6"></span>
                        </i>
                      </span>
                      <span class="menu-title">
                        {{ parent.name }}
                      </span>
                    </a>
                  </div>
                </ng-container>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div class="app-main flex-column flex-row-fluid" id="kt_app_main">
        <div class="d-flex flex-column flex-column-fluid">
          <div id="kt_app_content" class="app-content flex-column-fluid">
            <div id="kt_app_content_container" class="app-container container-fluid">
              <router-outlet (activate)="updatePageHeader($event)" (attach)="updatePageHeader($event)"
                (deactivate)="updatePageHeader(null)" (detach)="updatePageHeader(null)"></router-outlet>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</div>
